import { jsx, Fragment } from 'react/jsx-runtime';
import { cx } from 'class-variance-authority';
import { useNavigationContext } from '../NavigationContext/NavigationContext.js';

/**
 * Component that is made to look nearly identical to the ProductMenu,
 * but without the chevron and actual product menu functionality.
 */
const ProductHeader = ({ as, className, collapsedAppLogo, expandedAppLogo, ...rest }) => {
    const { isExpanded } = useNavigationContext();
    const Component = as || "a";
    return (jsx(Fragment, { children: jsx(Component, { "aria-label": "Morning Consult", className: cx("mci-flex mci-items-center mci-gap-5 mci-px-m mci-py-s -mci-outline-offset-2 mci-outline-brand mci-transition-colors mci-duration-fast", className), ...rest, children: isExpanded ? (jsx(Fragment, { children: jsx("span", { children: expandedAppLogo }) })) : (jsx("span", { className: "mci-w-full mci-max-w-[18px]", children: collapsedAppLogo })) }) }));
};

export { ProductHeader };
